import {useState, ReactNode} from 'react';

import {Radio} from '@udemy-v2/react-form-components';
import {Accordion} from '@udemy-v2/react-reveal-components';
import styles from './collapsible-purchase-section.module.scss';

export interface CollapsiblePurchaseSectionProps {
    title: ReactNode;
    children: ReactNode;
    defaultExpanded?: boolean;
    showRadio?: boolean;
}

export const CollapsiblePurchaseSection = ({
    title,
    children,
    defaultExpanded,
    showRadio = true,
}: CollapsiblePurchaseSectionProps) => {
    const [isSelected, setIsSelected] = useState(defaultExpanded);

    const wrappedTitle = (
        <div className={styles['radio-controlled-title-wrapper']}>
            {showRadio && (
                <div className={styles['radio']}>
                    <Radio size={'large'} checked={isSelected} readOnly={true} />
                </div>
            )}
            <div className={styles['radio-controlled-title']}>{title}</div>
        </div>
    );

    return (
        <Accordion.Panel
            defaultExpanded={defaultExpanded}
            onToggle={(expanded) => setIsSelected(expanded)}
            title={wrappedTitle}
        >
            <div className={styles['radio-controlled-content']}>{children}</div>
        </Accordion.Panel>
    );
};
